import React from "react";
import { StyledFieldLabel } from "./input-label.styles";

interface InputLabelProps {
  id?: string;
  text: string;
  required?: boolean;
}

export const InputLabelComponent: React.FC<InputLabelProps> = ({ id, text, required }) => {
  return (
    <StyledFieldLabel id={id} required={required}>
      {text}
    </StyledFieldLabel>
  );
};
